import {
    queryAll,
    queryFirst,
    scrollTo,
    addClass,
    removeClass,
    hasClass,
    toggleClass,
    setAttribute,
    removeAttribute
} from '../domUtil';

let observer = null;
const productContainer = queryFirst('.pdp-container');
const stickyCTAContainer = queryFirst('.js-sticky-cta-container');
const addToCartBtn = queryFirst('.add-to-cart', productContainer);
const notifyMeBtn = queryFirst('.notify-me-btn', productContainer);
const sizeHeaderEl = queryFirst('#cta-size-options-header', stickyCTAContainer);
const header = queryFirst('.main-header');
const headerHeight = header ? header.clientHeight + 40 : 0;
const masterId = productContainer.dataset.masterid;
const productInfo = window.productInfo[masterId];
const hiddenClass = 'd-none';
const sizeContainerEl = queryFirst('.size-accordion', productContainer);
let initSizeContainerHeight;

/**
 * @description Handle button visibility
 * @param {Object} data DOM event
 * @param {Object} container DOM event
 */
function handleButton(data, container) {
    const { selectedSizeElement } = data;
    const selectedColorId = queryFirst('.swatch-circle.selected').dataset.attrValue;
    const addToCartBtnCTA = queryFirst('.js-sticky-add-to-cart', container);
    const notifyCTA = queryFirst('.js-notify-cta', container);

    if (hasClass(selectedSizeElement, 'not-available')) {
        const selectedSizeValue = selectedSizeElement.dataset.attrValue;
        const variantGroupData = productInfo.variants[selectedColorId];
        const { sizes } = variantGroupData;
        const selectedSizeData = sizes[selectedSizeValue];
        const { isNotifyMeEnabled } = selectedSizeData;

        if (isNotifyMeEnabled) {
            observer.unobserve(addToCartBtn);
            observer.observe(notifyMeBtn);
            removeClass(notifyCTA, hiddenClass);
            addClass(addToCartBtnCTA, hiddenClass);
        } else {
            setAttribute(addToCartBtnCTA, 'disabled', true);
            addClass(sizeHeaderEl, 'm-error');
        }
    } else {
        observer.observe(addToCartBtn);
        observer.unobserve(notifyMeBtn);
        addClass(notifyCTA, hiddenClass);
        removeClass(addToCartBtnCTA, hiddenClass);
        removeAttribute(addToCartBtnCTA, 'disabled');
        removeClass(sizeHeaderEl, 'm-error');
    }
}

/**
 * @description Hide unselected fit accordions
 * @param {string} selectedFitValue Selected fit value
 */
function hideUnselectedFits(selectedFitValue) {
    const selectFitAccordions = queryAll('.js-fit-size-accordion');

    if (selectFitAccordions) {
        selectFitAccordions.forEach(selectFitAccordion => {
            if (selectFitAccordion.dataset.attrValue !== selectedFitValue) {
                addClass(selectFitAccordion, hiddenClass);
            }
        });
    }
}

/**
 * @description Update fit size accordion with available sizes
 * @param {Array<Object>} variationAttributes Product variation attributes
 */
function updateFitSizeAccordions(variationAttributes) {
    if (variationAttributes) {
        const fitSizeVariation = variationAttributes.find(item => item.id === 'fitSize');
        const sizeVariation = variationAttributes.find(item => item.id === 'size');
        const sizeAccordionContainer = queryFirst('.js-size-select-container .card-body');
        const fitSizeElements = queryAll('.js-size-select-container .js-fit-size-accordion');
        const selectedFit = fitSizeVariation.filteredValues.find(item => item.selected);
        const selectedFitValue = selectedFit ? selectedFit.value : '';
        const selectSizeBtn = queryFirst('.js-selected-size-btn');
        let sizeItemsMarkup = '';

        if (sizeVariation?.filteredValues.length) {
            sizeItemsMarkup = sizeVariation.filteredValues.reduce((markup, item) => {
                return markup
                + `<li>
                    <button
                        class="title btn text-left btn-block text-center js-size-select-btn
                        ${item.selected ? 'selected' : ''}
                        ${!item.inStock || item.forceOutOfStock ? 'not-available' : ''}"
                        data-attr-value="${item.id}"
                    >
                        ${item.displayValue}
                    </button>
                </li>`;
            }, '');
        }

        if (fitSizeVariation?.filteredValues?.length > 1) {
            const isRerenderNeeded = fitSizeVariation.filteredValues.some(fitValue => !queryFirst(`#cta-size-options-header-${fitValue.value}`));

            if (isRerenderNeeded || fitSizeElements.length !== fitSizeVariation.filteredValues.length) {
                const sizeSelectContentMarkup = fitSizeVariation.filteredValues.reduce((markup, fitValue) => {
                    return markup
                        + ` <li>
                                <div class="accordion-container js-fit-size-accordion d-none m-fit" data-attr-value="${fitValue.value}">
                                    <div class="card">
                                        <div class="card-header" id="cta-size-options-header-${fitValue.value}">
                                            <h5 class="mb-0">
                                                <button
                                                    class="title btn text-left btn-block collapsed js-selected-fit-btn"
                                                    data-attr-value="${fitValue.value}"
                                                    data-toggle="collapse"
                                                    data-target="${'#cta-size-options-' + fitValue.value}"
                                                    aria-expanded="false"
                                                    aria-controls="cta-size-options-${fitValue.value}"
                                                >
                                                    ${fitValue.value}
                                                </button>
                                            </h5>
                                        </div>
                                        <div
                                            id="cta-size-options-${fitValue.value}"
                                            class="sticky-cta-suboptions content value collapse"
                                            aria-labelledby="cta-size-options-header-${fitValue.value}"
                                        >
                                            <div class="card-body js-size-select-accordion" data-attr-value="${fitValue.value}">
                                                <ul>
                                                    ${fitValue.selected ? sizeItemsMarkup : ''}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>`;
                }, '');

                sizeAccordionContainer.innerHTML = `<ul class="scroll-shadows">${sizeSelectContentMarkup}</ul>`;

                // Collapse size accordion
                setAttribute(selectSizeBtn, 'aria-expanded', false);
                removeClass(queryFirst('#cta-size-options'), 'show');
            } else {
                const selectedFitSizeAccordion = queryFirst(`.js-size-select-accordion[data-attr-value="${selectedFitValue}"]`);

                if (selectedFitSizeAccordion) {
                    selectedFitSizeAccordion.innerHTML = `<ul>${sizeItemsMarkup}</ul>`;
                }
            }
        } else if (fitSizeVariation?.filteredValues?.length === 1 && sizeVariation?.filteredValues?.length) {
            sizeAccordionContainer.innerHTML = `<ul class="scroll-shadows">${sizeItemsMarkup}</ul>`;
            // Collapse size accordion
            setAttribute(selectSizeBtn, 'aria-expanded', false);
            removeClass(queryFirst('#cta-size-options'), 'show');
        }

        if (!sizeVariation?.filteredValues?.some(size => size.selected)) {
            const selectedSizeTitle = queryFirst('.js-selected-size-title');
            selectedSizeTitle.innerText = '';
        }

        setSizeSelectorDisabled(
            fitSizeVariation?.filteredValues?.length <= 1 && sizeVariation?.filteredValues.length === 1
        );
    }
}

/**
 * @description Disable size selector when only one size is available
 * @param {boolean} isDisabled Whether the size selector should be disabled
 */
function setSizeSelectorDisabled(isDisabled) {
    const selectSizeBtn = queryFirst('.js-selected-size-btn');

    if (!selectSizeBtn) {
        return;
    }

    if (isDisabled) {
        setAttribute(selectSizeBtn, 'disabled', true);
    } else {
        removeAttribute(selectSizeBtn, 'disabled');
    }
}

/**
 * @description Update Color Selector with selected color
 * @param {string} selectedColorValue Selected color value
 * @param {Object} data Data object
 */
function updateColorSelector(selectedColorValue) {
    const colorSelectorColor = queryFirst('.js-selected-color-swatch');
    const colorSelectBtns = queryAll('.js-color-select-btn');
    let selectedColorImageUrl = '';

    if (colorSelectBtns.length && colorSelectorColor) {
        colorSelectBtns.forEach(colorSelectBtn => {
            if (colorSelectBtn.dataset.attrValue === selectedColorValue) {
                selectedColorImageUrl = colorSelectBtn.dataset.imgUrl;
                addClass(colorSelectBtn, 'selected');
            } else {
                removeClass(colorSelectBtn, 'selected');
            }
        });

        colorSelectorColor.style.backgroundImage = `url(${selectedColorImageUrl})`;
    }
}

/**
 * @description Handle click on fitSize select button
 * @param {Event} event DOM event
 * @param {Object} response DOM event
 */
function onAttributeSelected(event, response) {
    const variationAttributes = response?.data?.product?.variationAttributes;
    let newSizeContainerHeight;

    if (variationAttributes) {
        updateFitSizeAccordions(response.data.product.variationAttributes);

        const colorAttr = variationAttributes.find(attr => attr.id === 'color');

        if (colorAttr) {
            const selectedColorValue = colorAttr.values.find(colorValue => colorValue.selected);

            if (selectedColorValue) {
                updateColorSelector(selectedColorValue.value);
            }
        }
    }

    newSizeContainerHeight = sizeContainerEl.clientHeight;

    // change scroll position if size container height changes
    if (hasClass(stickyCTAContainer, 'js-past-cta') && initSizeContainerHeight !== newSizeContainerHeight) {
        scrollTo(window.scrollY + newSizeContainerHeight - initSizeContainerHeight, 0);
    }

    initSizeContainerHeight = newSizeContainerHeight;
    handleButton(response, queryFirst('.js-sticky-cta'));
}

/**
 * @description Show all fit size selectors
 */
function showAllFitsSelectors() {
    const fitSizeSelectAccordions = queryAll('.js-fit-size-accordion');

    if (fitSizeSelectAccordions) {
        fitSizeSelectAccordions.forEach(fitSizeSelectAccordion => removeClass(fitSizeSelectAccordion, hiddenClass));
    }
}

/**
 * @description Handle click on fitSize select button and trigger click on fitSize tab on product details
 * @param {Event} event DOM event
 */
function onFitSizeSelectClick(event) {
    const selectedFitValue = event.target.dataset.attrValue;

    if (!hasClass(event.target, 'collapsed')) {
        showAllFitsSelectors();
    } else {
        hideUnselectedFits(selectedFitValue);
    }

    $(`.pdp-product-details .non-color-attribute.fit-product-type[data-attr-value="${selectedFitValue}"]`)
        .trigger('click');
}

/**
 * @description Handle click on size selector to collapse fit accordions
 * @param {Event} event DOM event
 */
function onSizeSelectorClick() {
    const fitSizeSelectBtns = queryAll('.js-selected-fit-btn');

    if (fitSizeSelectBtns && fitSizeSelectBtns.length) {
        fitSizeSelectBtns.forEach(fitSelectBtn => {
            if (!hasClass(fitSelectBtn, 'collapsed')) {
                const contentSelector = fitSelectBtn.dataset.target;
                const content = queryFirst(contentSelector);

                addClass(fitSelectBtn, 'collapsed');
                setAttribute(fitSelectBtn, 'aria-expanded', false);
                removeClass(content, 'show');
            }
        });
    }

    showAllFitsSelectors();
}

/**
 * @description Update CTA when size selected (update selected size and Add To Cart button)
 * @param {Event} event DOM event
 * @param {Object} data Data object
 */
function onPdpSizeSelected(event, data) {
    const { selectedSizeElement } = data;
    const selectedSizeValue = selectedSizeElement.dataset.attrValue;
    const selectedSizeTitle = queryFirst('.js-selected-size-title');
    const prevSelectedSize = queryFirst('.js-size-select-btn.selected');
    const sizeBtnToSelect = queryFirst(`.js-size-select-btn[data-attr-value="${selectedSizeValue}"]`);

    handleButton(data, queryFirst('.js-sticky-cta'));

    if (prevSelectedSize) {
        removeClass(prevSelectedSize, 'selected');
    }

    if (selectedSizeTitle) {
        selectedSizeTitle.innerText = `: ${selectedSizeValue}`;
    }

    if (sizeBtnToSelect) {
        addClass(sizeBtnToSelect, 'selected');
    }
}

/**
 * @description Sync sticky panel size selection and CTA with the already selected PDP size
 */
function syncStickyCtaWithSelectedSize() {
    const selectedSizeElement = queryFirst('.size-btn.selected', productContainer);
    const fitAccordions = queryAll('.js-fit-size-accordion', stickyCTAContainer);
    const sizeSelectBtns = queryAll('.js-size-select-btn', stickyCTAContainer);

    setSizeSelectorDisabled(fitAccordions.length <= 1 && sizeSelectBtns.length === 1);

    if (!selectedSizeElement) {
        return;
    }

    onPdpSizeSelected(null, {
        selectedSizeElement,
        productContainer
    });
}

/**
 * @description Handle color option button click
 * @param {Event} event DOM event
 */
function onColorSelect(event) {
    const selectedColorValue = event.target.dataset.attrValue;

    $(`.color-attribute[data-attr-value="${selectedColorValue}"]`).trigger('click');

    updateColorSelector(selectedColorValue);

    $('.js-selected-color-swatch-btn').trigger('click');
}

/**
 * @description Handle size option button click in CTA size selector
 * @param {Event} event DOM event
 */
function onSizeSelect(event) {
    const selectedSizeValue = event.target.dataset.attrValue;

    $(`.pdp-product-details .size-container .size-btn[data-attr-value="${selectedSizeValue}"]`).trigger('click');
    $('.js-selected-size-btn').trigger('click');
}

/**
 * @description Handle clicks on size selector
 * @param {Event} event DOM event
 */
function onSizeSelectContainerClick(event) {
    const target = event.target;

    if (hasClass(target, 'js-size-select-btn')) {
        onSizeSelect(event);
    }

    if (hasClass(target, 'js-selected-size-btn')) {
        onSizeSelectorClick(event);
    }

    if (hasClass(target, 'js-selected-fit-btn')) {
        onFitSizeSelectClick(event);
    }
}

/**
 * @description Init sticky CTA functionality
 * @param {JQuery} ctaElement DOM element for CTA component
 */
function initStickyCTAEl(ctaElement) {
    const addToCartBtnCTA = queryFirst('.js-sticky-add-to-cart', ctaElement);

    $('body').on('product:pdpSizeSelected', onPdpSizeSelected);
    $('body').on('product:afterAttributeSelect', onAttributeSelected);

    addToCartBtnCTA.addEventListener('click', () => {
        const selectedSize = queryFirst('.size-btn.selected');

        if (selectedSize) {
            $(addToCartBtn).trigger('click');
        } else {
            addClass(sizeHeaderEl, 'm-error');
        }
    });

    queryFirst('.js-notify-cta', ctaElement).addEventListener('click', () => {
        $(notifyMeBtn).trigger('click');
    });

    const colorSelectBtns = queryAll('.js-color-select-btn', ctaElement);

    if (colorSelectBtns) {
        colorSelectBtns.forEach((colorSelectBtn) => {
            colorSelectBtn.addEventListener('click', onColorSelect);
        });
    }

    const sizeSelectContainer = queryFirst('.js-size-select-container', ctaElement);

    sizeSelectContainer.addEventListener('click', onSizeSelectContainerClick);

    syncStickyCtaWithSelectedSize();
}

// CTA functionality Initialization

/**
 * @description Handles Add To Cart button intersection
 * @param {Array<Object>} entries Intersection Entries
 */
function onIntersection(entries) {
    if (!entries || !entries[0]) return;

    const entry = entries[0];
    const isMainCtaVisible = entry.isIntersecting;
    const hasPassedMainCta = !isMainCtaVisible && entry.boundingClientRect.bottom - headerHeight < 0;

    if (!hasClass(stickyCTAContainer, 'm-ready')) {
        requestAnimationFrame(() => {
            stickyCTAContainer.classList.add('m-ready');
        });
    }

    toggleClass(stickyCTAContainer, 'm-hidden', isMainCtaVisible);
    toggleClass(stickyCTAContainer, 'js-past-cta', hasPassedMainCta);

    if (!initSizeContainerHeight && sizeContainerEl) {
        initSizeContainerHeight = sizeContainerEl.clientHeight;
    }
}

/**
 * @description Initialize Add To Cart sticky CTA
 */
function initStickyCta() {
    if (stickyCTAContainer && addToCartBtn) {
        observer = new IntersectionObserver(onIntersection, {
            threshold: 0.01,
            rootMargin: header ? `-${headerHeight}px 0px 0px 0px` : '0px'
        });

        observer.observe(addToCartBtn);

        const stickyCTAEl = queryFirst('.js-sticky-cta');

        if (stickyCTAEl) {
            initStickyCTAEl(stickyCTAEl);
        }
    }
}

if (window.matchMedia('(max-width: 767px)').matches) {
    initStickyCta();
}
